export default __webpack_public_path__ + "static/onbrand-experience-80a71f767cd92120de6c081643de45f1.webp";